export default {
    name: 'TarefasMixin',
    data() {
        return {
            isSuporte: false
        }
    },
    inject: {
        erplayout: {
            default() {
                console.error('Main needs to be child of ErpLayout')
            }
        }
    },
    beforeMount() {
        this.testRoute()
    },
    mounted() {
        window.setTimeout(() => {
            this.erplayout.erpheader.setMenuModuleToggle(true)
        }, 10)
        document.body.classList.add('suporte-module-body')
        this.erplayout.erpheader.menu.setActiveMenu('suporte')
    },
    destroyed() {
        document.body.classList.remove('suporte-module-body')
    },
    beforeDestroy() {
        this.erplayout.erpheader.setMenuModuleToggle(false)
    },
    methods: {
        testRoute() {
            if (this.$route.query.suporte && this.$route.query.suporte == '1') {
                this.isSuporte = true
            } else {
                this.isSuporte = false
            }
        }
    }
}
